import "./index.scss";
import "./icons"
import('react')
import('react-router')
import('react-dom/client')
import('antd')
import('axios')
import React from 'react';
import ReactDOM from "react-dom/client";
// import {injectors} from "./injectors";
import {App} from "./App";
import {BrowserRouter} from "react-router";
import {LoadingBarContainer} from "react-top-loading-bar";

// declare global {
//   namespace JSX {
//     interface IntrinsicElements {
//       [elemName: string]: any;
//     }
//   }
// }
//
// injectors.forEach(i => {
//   const elements = document.querySelectorAll(i.selector)
//   elements.forEach(element => {
//     if (element) {
//       let props = {}
//       if (i.getprops) {
//         props = i.getprops(element)
//       }
//       console.log("Injecting", i.selector)
//       // @ts-ignore - avoid TSC complaining about different types of props
//       const c = React.createElement(i.component, props)
//       ReactDOM.createRoot(element).render(c)
//     }
//   })
// })

const root = document.getElementById("app-storefront-root");
if (root) {
  ReactDOM
    .createRoot(root)
    .render(
      (
        <LoadingBarContainer>
          <BrowserRouter>
            <App/>
          </BrowserRouter>
        </LoadingBarContainer>
      )
    );
}
